import { render, staticRenderFns } from "./BankReturnOverviewActionsSelector.vue?vue&type=template&id=5825945a&scoped=true"
import script from "./BankReturnOverviewActionsSelector.vue?vue&type=script&lang=js"
export * from "./BankReturnOverviewActionsSelector.vue?vue&type=script&lang=js"
import style0 from "./BankReturnOverviewActionsSelector.vue?vue&type=style&index=0&id=5825945a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825945a",
  null
  
)

export default component.exports